export default __webpack_public_path__ + "static/media/work.202a4256.jpg";